import { Controller } from "@hotwired/stimulus";

// <a> に data-bs-dismiss を付けると Bootstrap がクリックの既定動作を止めるため、
// 遷移やダウンロードをさせつつモーダルを閉じたいリンクはこちらを使う。
// Bootstrap は legacy / app の2バンドルに入っており、どちらもモーダルを開くので、
// 両方に閉じさせるためモーダル自身の閉じるボタンを押す。
export default class extends Controller {
  close() {
    const modal = this.element.closest(".modal");
    modal?.querySelector('button[data-bs-dismiss="modal"]')?.click();
  }
}
